import React from 'react';
import { SUPPORT_EMAIL, EFFECTIVE_DATE } from '../constants';
import './LegalModal.css';

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="legal-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <h2>Terms of Service</h2>
        <p className="effective-date">Effective Date: {EFFECTIVE_DATE}</p>
        
        <div className="legal-content">
          <section>
            <h3>1. Who We Are</h3>
            <p>
              Where's Junior ("the App") is operated by School 21 LLC dba DoZESQ Imaginarium 
              ("DoZESQ Imaginarium," "we," "our," or "us"). We created this project in collaboration 
              with the Jeffrey Lucas Gurmendi Marshall Foundation ("the Foundation"), which shares 
              our mission of fostering joy, kindness and mental well-being in youth and families. The Foundation is not the legal owner 
              or operator of the App.
            </p>
          </section>

          <section>
            <h3>2. Using the App</h3>
            <p>
              By visiting or posting on Where's Junior, you agree to these Terms. You may use the 
              App only for personal, non-commercial purposes and in accordance with these Terms.
            </p>
          </section>

          <section>
            <h3>3. User Content</h3>
            <p>
              You may upload or share text, photos, or videos ("Content"). You keep ownership of 
              your Content but grant us a non-exclusive license to display it on the App. Do not 
              post anything unlawful, harmful, or that violates others' rights. We may remove 
              Content at our discretion to maintain a respectful environment, or for whatever reason we deem appropriate.
            </p>
          </section>

          <section>
            <h3>4. Privacy</h3>
            <p>
              Our use of information is described in our Privacy Policy. In short: we collect only 
              what is necessary for basic operation, we do not sell or share your data, and we use 
              only essential cookies.
            </p>
          </section>

          <section>
            <h3>5. Intellectual Property</h3>
            <p>
              All software, design, and other materials on the App belong to DoZESQ Imaginarium or 
              its licensors. Please do not copy or reuse them without permission.
            </p>
          </section>

          <section>
            <h3>6. Disclaimer of Warranties</h3>
            <p>
              This App is provided "as is" without warranties of any kind. We strive for accuracy 
              and reliability but cannot guarantee uninterrupted or error-free operation.
            </p>
          </section>

          <section>
            <h3>7. Limitation of Liability</h3>
            <p>
              To the fullest extent permitted by law, School 21 LLC and DoZESQ Imaginarium are not 
              liable for any indirect or consequential damages arising from your use of the App.
            </p>
          </section>

          <section>
            <h3>8. Changes to These Terms</h3>
            <p>
              We may update these Terms periodically; the date above shows the latest version. 
              Continued use of the App means you accept the updated Terms.
            </p>
          </section>

          <section>
            <h3>9. Contact</h3>
            <p>
              Questions? Email us at{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
          </section>
        </div>
        
        <button className="close-button" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default TermsModal;